function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.115 2.13A3.393 3.393 0 0015.558.25a6.437 6.437 0 01-2.085.825A3.226 3.226 0 0011.077 0C9.265 0 7.795 1.523 7.795 3.401c0 .267.029.527.085.776C5.152 4.035 2.733 2.68 1.114.623a3.48 3.48 0 00-.445 1.71c0 1.18.58 2.22 1.46 2.83a3.183 3.183 0 01-1.486-.425v.043c0 1.648 1.131 3.023 2.633 3.335a3.18 3.18 0 01-1.483.059c.418 1.351 1.63 2.334 3.067 2.362A6.442 6.442 0 010 11.946a9.057 9.057 0 005.032 1.528c6.038 0 9.34-5.183 9.34-9.678 0-.148-.004-.294-.01-.44A6.811 6.811 0 0016 1.595a6.385 6.385 0 01-1.885.536z",
  fillRule: "evenodd"
});

function SvgTwitter(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 14",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

export default SvgTwitter;